"use client"

import { useTranslations } from "next-intl"
import { X } from "lucide-react"
import { cn } from "@/lib/utils"

type MessagingSafetyBannerProps = {
  visible: boolean
  onDismiss: () => void
  className?: string
}

export function MessagingSafetyBanner({ visible, onDismiss, className }: MessagingSafetyBannerProps) {
  const tChat = useTranslations("chat.guidelines")
  if (!visible) return null

  return (
    <div
      className={cn(
        "relative isolate z-10 mb-3 grid grid-cols-[2rem_1fr_2rem] items-center rounded-2xl border border-amber-300 bg-amber-50 px-2 py-2.5 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-950 dark:text-amber-100",
        className,
      )}
      role="status"
    >
      <span aria-hidden="true" className="h-8 w-8" />
      <p className="text-center leading-snug">{tChat("banner")}</p>
      <button
        type="button"
        onClick={onDismiss}
        className="flex h-8 w-8 shrink-0 items-center justify-center justify-self-end rounded-full hover:bg-amber-200/80 dark:hover:bg-amber-900"
        aria-label={tChat("dismissBanner")}
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  )
}
